var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon rounded-circle d-flex align-items-center justify-content-center text-white",class:`project-${parseInt(_vm.project.Code)}`,style:({width: _vm.width, height: _vm.width})},[_c('div',[_vm._v(_vm._s(_vm._f("numeral")(parseInt(_vm.project.Code),'000')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }